export const MAX_SHORT_TEXT_FIELD_CHARS = 250 as const;
export const MAX_PARAGRAPH_FIELD_CHARS = 1000 as const;
